import React, { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import Fontstyling from "../../../components/common/comman";
import toastFile from "../../../Service/ToastFile";
import { useFormik } from "formik";
import * as Yup from "yup";
import Required from "../../../components/Required";
import { useRef } from "react";
import { getClientsDatabyPaginationbySearch } from "../../../api/User/commonApi";
import { AsyncPaginate } from "react-select-async-paginate";
import { GetListOfClinicalTeamMemberDetails } from "../../../api/ClinicalIntake/ClinicalTeamMemberApi";
import { Clinical_Support_Request } from "../../../api/Admin/serviceApi";
import { Loader } from "rsuite";

const schema = Yup.object().shape({
  client_Type: Yup.string().notOneOf(
    ["0", null, "", 0],
    "Please select client type"
  ),
  clinician: Yup.string().notOneOf(
    ["0", null, "", 0],
    "Please select clinician"
  ),
  client_Name: Yup.object().nonNullable().required("Please select client name"),
  description: Yup.string().required("Please enter description here"),
  // file: Yup.mixed().required("Please upload file"),
});
const ClinicalSupport = () => {
  const user = useSelector((state) => state.userDetails.value);
  const [clientData, setClientData] = useState([]);
  const [clinicianData, setClinicianData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fileRef = useRef();

  const customStyles = {
    control: (base) => ({
      ...Fontstyling.primaryparagraph,
      display: "flex",
      alignItems: "center",
      border: `1px solid  ${
        errors.client_Name && touched.client_Name ? "red" : "#ced4da"
      }`,
      borderRadius: "0px",
      width: "100%",
      minHeight: "28px",
      maxHeight: "28px",
      textAlign: "left",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        ...Fontstyling.primaryparagraph,
        textAlign: "left",
        backgroundColor:
          data.value === 0 ? "#fff" : isFocused ? "#3498ff" : null,
        color: data.value === 0 ? "#808080" : isFocused ? "white" : "#212529",
        fontSize: 12,
        paddingTop: 0,
        paddingBottom: 0,
      };
    },
  };

  useEffect(() => getClinician(), []);

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await getClientsDatabyPaginationbySearch(
          user.UD_id,
          page,
          searchQuery
        );
        const data = await response.data.clientsDataModelUDid;
        setClientData([...clientData, ...data]);
        const newOptions = data.map((port) => ({
          value: port.clientID,
          label: port.clientName,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };

  const getClinician = () => {
    GetListOfClinicalTeamMemberDetails().then((res) => {
      setClinicianData(res.data.data);
    });
  };

  const handleActions = (values, { resetForm }) => {
    setIsLoading(true);
    const clinicianObj = clinicianData.find(
      (item) => item.Id === +values.clinician
    );
    const formDataForAxios = new FormData();
    let formData = {
      ClientName: values.client_Name.label,
      ClientType: values.client_Type,
      RequestorEmail:user?.UD_emp_email,
      MemberID: values.member_Id,
      Clinician: clinicianObj?.DoctorName,
      RequestDescription: '<br>'+values.description.replace(/\n/g, '<br>'),
      ClinicianEmail: clinicianObj?.EmailId,
      RequestorName:user?.UD_emp_name,
      CreatedBy: +user?.UD_id,
      Attachment: values.file,
    };
    for (const key in formData) {
      formDataForAxios.append(key, formData[key]);
    }
    Clinical_Support_Request(formDataForAxios)
      .then((res) => {
        if (
          (res?.status === 200 || res?.status === 204) &&
          res.data.issuccess
        ) {
          toastFile("new");
          resetForm();
          fileRef.current.value = "";
        } else {
          toastFile(res.data.massage, "error");
        }
      })
      .catch((err) => {
        console.log(err)
        toastFile(err.response.data, "error");
      })
      .finally((re) => setIsLoading(false));
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setValues,
    values,
    touched,
    isValid,
    errors,
  } = useFormik({
    validationSchema: schema,
    onSubmit: handleActions,
    initialValues: {
      client_Name: null,
      client_Type: 0,
      clinician: 0,
      member_Id: "",
      description: "",
      file: undefined,
    },
  });

  return (
    <div>
      <div className="d-flex align-item-center justify-content-between py-3 ">
        <div style={Fontstyling.heading}>Clinical Support Request</div>
      </div>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-2 gap-3">
          <Col>
            <Form.Group className="text-start">
              <Form.Label className="text-nowrap" style={Fontstyling.label}>
                Client Name
                <Required />
              </Form.Label>
              <AsyncPaginate
                value={values.client_Name || null}
                loadOptions={loadOptions}
                debounceTimeout={2500}
                styles={customStyles}
                placeholder="Select Client Name"
                onChange={(option) => {
                  setFieldValue("client_Name", option);
                }}
                onBlur={handleBlur}
                additional={{
                  page: 1,
                }}
                isSearchable={true}
                isOptionDisabled={(e) => e.value === 0}
              />
              {errors.client_Name && touched.client_Name && (
                <Form.Label
                  className="text-wrap text-danger fw-bold"
                  style={Fontstyling.label}
                >
                  {errors.client_Name}
                  <Required />
                </Form.Label>
              )}
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="text-start">
              <Form.Label className="text-nowrap" style={Fontstyling.label}>
                Client Type
                <Required />
              </Form.Label>
              <Form.Select
                className="rounded-0"
                style={Fontstyling.dropdown_label}
                name="client_Type"
                onChange={handleChange}
                value={values.client_Type}
                onBlur={handleBlur}
                isInvalid={touched.client_Type && errors.client_Type}
              >
                <option value={0}>Select Client Type</option>
                <option value={"Fully-Insured"}>Fully-Insured</option>
                <option value={"Level-Funded"}>Level-Funded</option>
                <option value={"Self-Funded"}>Self-Funded</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.client_Type}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-2 gap-3">
          <Col>
            <Form.Group className="text-start mt-2">
              <Form.Label className="text-nowrap" style={Fontstyling.label}>
                Member ID
              </Form.Label>
              <Form.Control
                name="member_Id"
                value={values.member_Id}
                className="rounded-0 py-1"
                type="text"
                placeholder="Member ID"
                style={Fontstyling.label}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Form.Group>
            {errors.member_Id && touched.member_Id && (
              <Form.Label style={Fontstyling.errorlabel}>
                {errors.member_Id}
              </Form.Label>
            )}
          </Col>
          <Col>
            <Form.Group className="text-start mt-2">
              <Form.Label className="text-nowrap" style={Fontstyling.label}>
                Clinician
                <Required />
              </Form.Label>
              <Form.Select
                className="rounded-0"
                style={Fontstyling.dropdown_label}
                name="clinician"
                onChange={handleChange}
                value={values.clinician}
                onBlur={handleBlur}
                isInvalid={touched.clinician && errors.clinician}
              >
                <option value={0}>Select Clinician</option>
                {clinicianData?.map((item, index) => {
                  return (
                    <option value={item.Id} key={index}>
                      {item.DoctorName}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.clinician}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-2 gap-3">
          <Col>
            <Form.Group className="text-start mt-2">
              <Form.Label className="text-nowrap" style={Fontstyling.label}>
                Description of Request
                <Required />
              </Form.Label>
              <Form.Control
                name="description"
                as="textarea"
                type="text"
                placeholder="Leave a description here"
                style={{
                  ...Fontstyling.label,
                  minHeight: "300px",
                  border: `1px solid ${
                    errors.description && touched.description
                      ? "red"
                      : "lightgrey"
                  }`,
                }}
                value={values.description}
                onChange={handleChange}
              />
            </Form.Group>
            {errors.description && touched.description && (
              <Form.Label style={Fontstyling.errorlabel}>
                {errors.description}
              </Form.Label>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label
                htmlFor="file"
                style={Fontstyling.label}
                className="form-label text-nowrap mt-2"
              >
                Attachment
              </Form.Label>
              <Form.Control
                className="rounded-0 py-1"
                style={Fontstyling.label}
                type="file"
                name="file"
                id="file"
                ref={fileRef}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("file", e.currentTarget.files[0]);
                }}
                // onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="d-flex align-items-center justify-content-end gap-3 my-4">
          <button
            style={Fontstyling.savebutton}
            type="submit"
            className="d-flex align-items-center justify-content-center"
            disabled={isLoading}
          >
            {isLoading ? <Loader className="me-2" content="Submit..." /> : "Submit"}
          </button>
        </div>
      </Form>
    </div>
  );
};

export default ClinicalSupport;
